// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0398ab19","453":"213ee43c","455":"747c259c","977":"c3434556"}[chunkId] + ".chunk.js";
};